<div class="container container-wrapper h-100">
  <div class="row h-100 justify-content-center align-items-center text-center">
    <div class="col-12 col-xl-11">
      <h3>{{ 'Thanks, your inquiry was sent successfully'| translate }}</h3>
      <div class="row justify-content-center mt-5">
        <div class="d-md-flex justify-content-md-center col-sm-5">
          <app-button [title]="'Next' | translate" (clickEvent)="onNext()"></app-button>
        </div>
      </div>
    </div>
  </div>
</div>
